export const getters = {
  list: state => state.list,
  expenses: state => state.expenses,
  staff_list: state => state.staff_list,
  companies_info: state => state.companies_info,
  inventory: state => state.inventory,
  model: state => state.model,
  rules: state => state.rules,
  columns: state => state.columns,
  filter: state => state.filter,
  pagination: state => state.pagination,
  sort: state => state.sort 
};
